var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 25,
    x2: 90,
    y2: 25,
    stroke: "#555",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 8,
    fill: "#8a76db"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderWidget);
export default __webpack_public_path__ + "static/media/slider-widget.716f21c944968c710e940cf1ae575e49.svg";
export { ForwardRef as ReactComponent };